import { useTranslation } from 'react-i18next';
import { CONNECTED_TURNAROUND_TEST_IDS } from '@connect-x-app/web-test-ids';

import './UnsupportedPart.scss';

export const UnsupportedPart = () => {
  const { t } = useTranslation();

  return (
    <p className="unsupported-part" data-test={CONNECTED_TURNAROUND_TEST_IDS.messages.unsupported}>
      {t('CONNECTED_TURNAROUND.UNSUPPORTED_CONTENT')}
    </p>
  );
};
